import React, { useState } from "react";
import Styles from "../../assets/scss/HelpCenterNormalUser/HelpCenterAdmin.module.scss";
import { FaEdit, FaEye, FaTrash } from "react-icons/fa";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import Pagination from "../../Components/Common/Pagination";
import AddIssuePopup from "./AddIssuePopup";
import PopupWrapper from "../../Components/Common/PopupWrapper";
import DeleteConfirmModalLogout from "../../Components/Common/DeleteConfirmModalLogout";
import { useGetEnquiryIssuesQuery, useDeleteEnquiryIssueMutation, useGetEnquiriesAdminQuery } from "../../slices/admin/admin";
import { toast } from "react-toastify";
import HelpCenterAdmiForm from "./HelpCenterAdmiForm";
import { useNavigate } from "react-router-dom";
import { FaArrowRightToBracket } from "react-icons/fa6";


const HelpCenterAdmin = () => {
    const [showCategoryTable, setShowCategoryTable] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const [search, setSearch] = useState("");

    const {
        data: enquiryRes,
        isLoading: enquiryLoading,
    } = useGetEnquiriesAdminQuery({
        offset: currentPage,
        limit: limit,
        search: search,   // ✅ added
    });

    const navigate = useNavigate();


    const [showFormPopup, setShowFormPopup] = useState(false);

    /* POPUP STATE */
    const [showAddIssuePopup, setShowAddIssuePopup] = useState(false);
    const [editItem, setEditItem] = useState(null);

    /* DELETE MODAL STATE */
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [deleteEnquiryIssue, { isLoading: deleteLoading }] =
        useDeleteEnquiryIssueMutation();

    /* TICKET DATA (STATIC – API later) */
    const ticketData = enquiryRes?.data || [];
    const totalTickets = enquiryRes?.total || 0;

    console.log(ticketData, "ticketDataticketData");



    /* GET ISSUES API */
    const {
        data: issueResponse,
        isLoading: issueLoading,
        isError: issueError,
    } = useGetEnquiryIssuesQuery();

    const categoryData = issueResponse?.data || [];

    /* PAGINATION */


    const activeData = showCategoryTable ? categoryData : ticketData;

    const totalPages = showCategoryTable
        ? Math.ceil(categoryData.length / limit)
        : Math.ceil(totalTickets / limit);

    const paginatedData = activeData;


    /* OPEN DELETE POPUP */
    const handleDeleteClick = (item) => {
        setSelectedItem(item);
        setDeleteModalOpen(true);
    };

    /* CONFIRM DELETE (API later) */
    const confirmDelete = async () => {
        try {
            if (showCategoryTable && selectedItem?._id) {
                await deleteEnquiryIssue(selectedItem._id).unwrap();
                toast.success("Enquiry Issue Deleted Successfully");
            }

            setDeleteModalOpen(false);
            setSelectedItem(null);
        } catch (error) {
            toast.error(error?.data?.message || "Delete failed");
        }
    };
    const handleClosePopup = () => {
        setShowAddIssuePopup(false);
        setEditItem(null);           // ✅ RESET EDIT STATE
    };

    const handleView = (enquiryId) => {
        navigate("/dashboard/HelpCenterAdminView", {
            state: { enquiryId },
        });
    };
    return (
        <div className={Styles.parent}>
            <div className={Styles.box}>
                {/* HEADER */}
                <div className={Styles.formHeader}>
                    <>

                        <h1 className={Styles.headerTitle}>Help Center Admin</h1>
                        {/* {!showCategoryTable && (
                            <button
                                className={Styles.addBtn}
                                onClick={() => setShowFormPopup(true)}
                            >
                                + Add Ticket
                            </button>
                        )} */}

                    </>
                </div>



                <div className={Styles.headerRow}>
                    <div className={Styles.headerActions}>
                        <input
                            type="text"
                            placeholder="Search..."
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setCurrentPage(1); // reset page when searching
                            }}
                            className={Styles.searchInput} />


                        <button
                            className={Styles.clearBtn}
                            onClick={() => {
                                setSearch("");
                                setCurrentPage(1);
                            }}
                        >
                            Clear Filter
                        </button>


                    </div>
                    <div className={Styles.headerActions}>
                        {!showCategoryTable && (
                            <button
                                className={Styles.addBtn}
                                onClick={() => setShowFormPopup(true)}
                            >
+ Create Ticket                            </button>
                        )}

                        {showCategoryTable && (
                            <button
                                className={Styles.addBtn}
                                onClick={() => {
                                    setEditItem(null);
                                    setShowAddIssuePopup(true);
                                }}
                            >
                                + Add New Issue
                            </button>
                        )}

                        <button
                            className={Styles.toggleBtn}
                            onClick={() => {
                                setShowCategoryTable((prev) => !prev);
                                setCurrentPage(1);
                            }}
                        >
                            {showCategoryTable ? "Show Tickets" : "Show Issues"}
                        </button>
                    </div>

                </div>

                {/* ISSUE TABLE */}
                {showCategoryTable && (
                    <table className={Styles.customTable}>
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Issue Type</th>
                                <th>Description</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* LOADING */}
                            {issueLoading && (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: "center" }}>
                                        Loading...
                                    </td>
                                </tr>
                            )}

                            {/* ERROR */}
                            {!issueLoading && issueError && (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: "center", color: "red" }}>
                                        Failed to load issues
                                    </td>
                                </tr>
                            )}

                            {/* NO DATA FOUND */}
                            {!issueLoading &&
                                !issueError &&
                                categoryData.length === 0 && (
                                    <tr>
                                        <td colSpan="5" style={{ textAlign: "center", color: "gray", fontWeight: "600", fontSize: "18px", }}>
                                            No data found
                                        </td>
                                    </tr>
                                )}

                            {/* DATA ROWS */}
                            {!issueLoading &&
                                !issueError &&
                                categoryData.length > 0 &&
                                paginatedData.map((item, index) => (
                                    <tr key={item._id}>
                                        <td>{index + 1}</td>
                                        <td>{item.issueName}</td>
                                        <td>{item.description || "-"}</td>
                                        <td>{item.isActive ? "Active" : "Inactive"}</td>
                                        <td>
                                            <div style={{ display: "flex", gap: "10px" }}>
                                                <FaEdit
                                                    className={Styles.deleteIcon}
                                                    onClick={() => {
                                                        setEditItem(item);
                                                        setShowAddIssuePopup(true);
                                                    }}
                                                />

                                                <FaTrash
                                                    className={Styles.deleteIcon}
                                                    onClick={() => handleDeleteClick(item)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>

                    </table>
                )}

                {/* TICKET TABLE */}
                {!showCategoryTable && (
                    <table className={Styles.customTable}>
                        <thead>
                            <tr>
                                <th>Ticket No</th>
                                <th>User</th>
                                <th>Phone</th>
                                <th>Mode of Contact</th>
                                <th>Status</th>
                                <th>Description</th>
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* LOADING */}
                            {enquiryLoading && (
                                <tr>
                                    <td colSpan="6" style={{ textAlign: "center" }}>
                                        Loading...
                                    </td>
                                </tr>
                            )}

                            {/* NO DATA */}
                            {!enquiryLoading && ticketData.length === 0 && (
                                <tr>
                                    <td colSpan="6" style={{ textAlign: "center" }}>
                                        No tickets found
                                    </td>
                                </tr>
                            )}

                            {/* DATA */}
                            {!enquiryLoading &&
                                ticketData.map((item) => (
                                    <tr key={item._id}>
                                        <td>{item.enquiryId}</td>

                                        <td>
                                            {item.userId
                                                ? `${item.userId.firstName} ${item.userId.lastName}`
                                                : "-"}
                                        </td>

                                        <td>{item.userId?.phone || "-"}</td>
                                        <td>{item?.modeOfContact || "-"}</td>
                                        <td>
                                            <span
                                                className={
                                                    item.status === "completed"
                                                        ? Styles.statusCompleted
                                                        : item.status === "inprogress"
                                                            ? Styles.statusInProgress
                                                            : Styles.statusPending
                                                }
                                            >
                                                {item.status}
                                            </span>
                                        </td>
                                        <td>{item.comments || "-"}</td>
                                        <td>
                                            {new Date(item.createdAt).toLocaleString("en-IN", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                            })}
                                        </td>

                                        <td>
                                            <FaArrowRightToBracket
                                                className={Styles.deleteIcon}
                                                style={{ cursor: "pointer" }}
                                                onClick={() => handleView(item._id)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                        </tbody>

                    </table>
                )}

                {/* PAGINATION */}
                <div className={Styles.paginationContainer}>
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                    />

                    <select
                        value={limit}
                        className={Styles.inputsbtn}
                        onChange={(e) => {
                            setLimit(Number(e.target.value));
                            setCurrentPage(1);
                        }}
                    >
                        <option value={10}>10 rows</option>
                        <option value={25}>25 rows</option>
                        <option value={50}>50 rows</option>
                    </select>
                </div>
            </div>

            {/* ADD ISSUE POPUP */}
            {showAddIssuePopup && (
                <PopupWrapper onClose={handleClosePopup}>
                    <AddIssuePopup editData={editItem} onClose={handleClosePopup} />
                </PopupWrapper>
            )}
            {showFormPopup && (
                <PopupWrapper onClose={() => setShowFormPopup(false)}>
                    <HelpCenterAdmiForm
                        onSuccess={() => setShowFormPopup(false)}
                        onClose={() => setShowFormPopup(false)}   // ✅ THIS WAS MISSING
                    />
                </PopupWrapper>
            )}


            {/* DELETE CONFIRM POPUP */}
            <DeleteConfirmModalLogout
                isOpen={deleteModalOpen}
                onConfirm={confirmDelete}
                onCancel={() => setDeleteModalOpen(false)}
                title="Are You Sure?"
                heading="Delete Item"
                content={`Are you sure you want to delete "${showCategoryTable
                    ? selectedItem?.issueName
                    : selectedItem?.ticketNo
                    }"? This action cannot be restored.`}

            />
        </div>
    );
};

export default HelpCenterAdmin;

